enum BackgroundJobName {
  ProcessConversation = "ProcessConversation",
}
export default BackgroundJobName;
